import { combineReducers } from 'redux'

import { currentMessageTemplateSlice } from './currentMessengerMessageTemplateSlice'
import { messageTemplateSlice } from './messengerMesssageTemplatesSlice'

export const messengerReducer = combineReducers({
  currentMessageTemplate: currentMessageTemplateSlice.reducer,
  messageTemplates: messageTemplateSlice.reducer,
})
